<template>
  <div class="full-text-select-page">
    <p class="page-tip">
      右侧 <span class="blue">同篇、同段、同句</span> 仅影响同一个文本框内的关键词
      <el-tooltip
        effect="dark"
        content="同一个文本框内的多个关键词用 空格 或者 +加号 分隔开时才能启用同段、同句。"
        placement="top"
      >
        <i class="el-icon-question" />
      </el-tooltip>
    </p>
    <inputItem
      v-if="labelOrigin.result && labelOrigin.result.length && paragraphArrGroup.length"
      :type.sync="labelOrigin.type"
      :defaultFilter.sync="labelOrigin.result"
      :paragraphArrGroup="paragraphArrGroup"
      :itemIndex="0"
      @setTopItem="setTopItem"
    />
    <p class="add-tip">
      <span class="blue add" @click="clickHandel(labelOrigin)"><i class="el-icon-plus" /> 添加条件组</span>
    </p>
  </div>
</template>

<script>
import { uniqueId, groupBy, uniqBy } from 'lodash';
import { services } from '@/service';
import { sysCaseWays, sysDataWays } from '@/constant';

import inputItem from './components/inputItem';

export default {
  components: {
    inputItem
  },
  data() {
    return {
      paragraphArr: [],
      labelOrigin: {}
    };
  },
  props: {
    label: {
      type: Object,
      required: true
    },
    instrumentType: {
      type: String,
      default: '裁判文书'
    }
  },
  watch: {
    labelOrigin: {
      handler(val) {
        this.$emit('updateLabel', val);
      },
      deep: true
    }
  },
  computed: {
    paragraphArrGroup() {
      const paraContnetItem = this.paragraphArr.find(o => o.key === 'para_content');
      const groupObj = groupBy(this.paragraphArr, 'groups');

      return sysDataWays.map(groupName => {
        if (groupName !== this.instrumentType) {
          return { groupName, data: [] };
        }
        const groupList = [...(groupObj[groupName] || [])];
        if (sysCaseWays.includes(this.instrumentType)) {
          groupList.unshift({
            key: 'fullreason.keyword',
            value: '案由',
            groups: this.instrumentType
          });
        }
        if (paraContnetItem) {
          groupList.unshift({ ...paraContnetItem, groups: groupName });
        }
        return { groupName, data: uniqBy(groupList, 'key') };
      });
    }
  },
  mounted() {
    this.labelOrigin = this.label;
    this.initParagraph();
  },
  methods: {
    setTopItem(item) {
      this.labelOrigin.result = item;
    },
    async initParagraph() {
      try {
        this.paragraphArr = await services.labelRelation.getParagraph();
      } catch (err) {
        console.error(err);
      }
    },
    clickHandel(labelOrigin) {
      // 首次点击所有都没有子集时，增加子集，否则增加分组
      const flag = labelOrigin.result.every(i => i.result.length === 0 || !i.result);
      if (flag) {
        // 首次点击，将所有一级分组合并到第一级的子集效果
        const result = labelOrigin.result.map(i => {
          return this.fetchPeerInfo(i);
        });
        labelOrigin.result = [{ ...this.fetchPeerInfo(), result }, this.fetchPeerInfo()];
      } else {
        // 增加同级分组
        labelOrigin.result.push(this.fetchPeerInfo());
      }
    },
    // 增加同级
    fetchPeerInfo(item = {}) {
      return {
        id: `${Date.now()}_${uniqueId()}`,
        value: item.value || '',
        keyword: item.keyword || 'para_content',
        searchLimit: item.searchLimit || '同篇',
        searchLimitDis: false,
        result: [],
        type: 'must'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.full-text-select-page {
  margin-top: -30px;
  .page-tip {
    position: relative;
    left: -10px;
    font-size: 12px;
    .el-icon-question {
      color: #4d4d4d;
      font-size: 16px;
      position: relative;
      top: 1px;
    }
  }
  .add-tip {
    position: relative;
    left: -17px;
    font-size: 12px;

    .add {
      cursor: pointer;
      font-size: 14px;
      margin-right: 8px;
    }
  }
  .blue {
    color: #409eff;
  }
}
</style>
